"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

import { useInvalidateCommunityQueries } from "./utils/useInvalidateCommunityQueries";

const urlBackendPath =
  "/communities/{community_id}/members/{user_id}/approve" as const;

/**
 * Approves a pending community join request (POST, no body). On success it
 * invalidates the community queries so the admin/member/requests lists and their
 * counts refresh (the approved user leaves Requests and appears in Members).
 */
export const useRequestCommunityMemberApprove = ({
  id,
  ...props
}: { id: number } & Partial<
  UseOpenApiMutationOptions<typeof urlBackendPath, "POST">
>) => {
  const invalidateCommunityQueries = useInvalidateCommunityQueries({ id });

  return useOpenApiMutation({
    method: "POST",
    onSuccess: (data, variables, context) => {
      invalidateCommunityQueries();
      props.onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
